export function autoResize(event: any) {
  const autoResize = event.target
  autoResize.style.height = "auto"
  autoResize.style.height = `${autoResize.scrollHeight}px`

  return autoResize
}
